<template>
  <EditComponent v-bind:kimono="kimono"   v-bind:obi="obi"  v-bind:obijime="obijime">
  <template v-slot:header>
  Obi Name
  </template>
  <table style="width:50%">
   <tr>
     <td><b>Typ</b></td>
     <td>Yukata Gürtel</td>
   </tr>
   <tr>
     <td><b>Farbe</b></td>
     <td>Schwarz</td>
   </tr>
   <tr>
     <td><b>Formalität</b></td>
     <td>formal</td>
   </tr>
  </table>
</EditComponent>
</template>

<script>
import EditComponent from '../components/EditComponent.vue'


export default {
  name: 'Obi',
  components: {
    EditComponent
  },
  props: {
    kimono: String,
    obi: String,
    obijime: String,
    showbutton: Boolean
  }
}
</script>
